<template>
    <div class="main partner">
        <Header></Header>
        <div class="content">

            <div class="box">
                <cardHead title="养殖概况分析"></cardHead>
                <div class="box-content">
					<div class="box-item">
					    <div class="chart_item mb38">
					        <chartTitle title="配种分析" :tabList='[]'></chartTitle>
					        <div class="total">
					            <div class="total_item">
					                <span>306</span>
					                <label>配种数量(只)</label>
					            </div>
					            <div class="total_item c_00FEFF ml_lg">
					                <span>302</span>
					                <label>怀孕总数(只)</label>
					            </div>
					            <div class="total_item c_00FEFF">
					                <span>65</span>
					                <label>新产总数(只)</label>
					            </div>
					            <div class="total_item c_00FEFF">
					                <span>3</span>
					                <label>久配未孕(只)</label>
					            </div>
					        </div>
					        <div class="bar_chart" id="barChart"></div>
					    </div>
						<div class="chart_item">
						    <chartTitle title="出生数量/断奶数量分析" :tabList='tabList' @changeTab="changeTab3"></chartTitle>
						    <div class="ring_chart" id="lineChart1" style="height: 3.5rem;margin-right: 0;"></div>
						</div>
					    
					</div>
                    <div class="box-item">
                        <div class="chart_item mb38">
                            <chartTitle title="繁殖双羔 " :tabList='tabList' @changeTab="changeTab1"></chartTitle>
                            <div class="total">
                                <div class="total_item">
                                    <span>56</span>
                                    <label>双羔数量(只)</label>
                                </div>
                                <div class="total_item">
                                    <span>16%</span>
                                    <label>双羔占比</label>
                                </div>
                                <!-- <div class="total_item">
                                    <span>125</span>
                                    <label>出栏总数(只)</label>
                                </div> -->
                            </div>
                            <div class="line_chart" id="lineChart"></div>
                        </div>
                        
						<div class="chart_item">
						    <chartTitle title="疫病分析" :tabList='tabList' @changeTab="changeTab4"></chartTitle>
						    <div class="total">
						        <div class="total_item" @click="goDialog('发病数量')">
						            <span>1</span>
						            <label>发病数量(只)</label>
						        </div>
						        <div class="total_item c_00FEFF" @click="goDialog('治愈总数')">
						            <span>1</span>
						            <label>治愈总数(只)</label>
						        </div>
						    </div>
						    <div class="bar_chart1" id="barChart1"></div>
						</div>
						
						
						
                    </div>
                  
                    <div class="box-item">
                        <div class="chart_item mb38">
                            <chartTitle title="死亡/淘汰数据分析" :tabList='tabList' @changeTab="changeTab2"></chartTitle>
                            <div class="pie_box">
                                <div class="pie_chart1" id='pieChart1'></div>
                                <div class="pie_chart2" id='pieChart2'></div>
                            </div>
                        </div>
                        <div class="chart_item">
                            <chartTitle title="初检数据分析" :tabList='tabList' @changeTab="changeTab5"></chartTitle>
                            <div class="ring_box">
                                <div class="ring_chart1" id="ringChart1"></div>
                                <div class="ring_legend">
                                    <div class="legend_item" v-for='(item, index) in ringData1' :key="index">
                                        <div>
                                            <span class="legend_pint" :style='{ background: ringColor[index] }'></span>
                                            {{ item.name }}
                                        </div>
                                        <div>{{ item.value }}只</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="dialog-box" v-if="isShow">
            <div class="dialog">
                <div class="headers">
                    <span>{{ dialogTxet }}</span>
                    <span class="el-icon-close" @click="close"></span>
                </div>
                <dv-scroll-board :config="config" @click="details" @mouseover='mouseover'
                    style="width:11.24rem;height:4rem;margin-top:0.1rem;padding: 0 .11rem;" />
            </div>
        </div>
    </div>
</template>
<script>
import cardHead from "./components/cardHead.vue";
import chartTitle from './components/chartTitle.vue'
import Header from "@/views/yqScreen/components/header.vue";
export default {
    components: {
        cardHead,
        chartTitle, Header, 
    },
    data() {
        return {
            config: {
                header: ['耳标编码', '预警时间', '预警说明', '操作'],
                data: [],
                align: ['center', 'left', 'left', 'left', 'left'],
                // columnWidth: [160, 180, 180, 320, 180, 180],
                headerHeight: 40,
                rowNum: 6,
                waitTime: 2000
            },
            dialogTxet: "",
            isShow: false,
            tabList: [
                { text: '近1月', value: 1 },
                { text: '近3月', value: 3 },
                { text: '近6月', value: 6 },
            ],
            ringColor: ['#00FEFF', '#1981FF', '#5D2CFE'],
            ringData1: [
                {
                    value: 290,
                    name: '怀孕'
                },
                {
                    value: 71,
                    name: '未怀孕'
                },
                {
                    value: 4,
                    name: '流产'
                }
            ],
			monthDays:[]
        };
    },
    watch: {},
    created() {
		this.getLastMonth()
    },
    mounted() {
        this.$nextTick(() => {
            this.lineChart({
                dom: 'lineChart',
                xAxis:this.getLastMonth(31),
                data: [14, 25, 35, 30, 49, 35, 20,26, 36, 30, 49, 35,20,16,18,26, 36, 30, 49, 35,20,16,18,21,26,21,31,22,23,25],
                data1: [23, 12, 27, 39, 40, 30, 21,15, 26, 36, 30, 49, 35,20,16,18,17,17,16,19,14,15,16,17,18,19,26,21,31,22]
            })
			this.lineChart1({
			    dom: 'lineChart1',
			    xAxis: this.getLastMonth(31),
			    data: [15, 26, 36, 30, 49, 35,20,16,18,17,17,16,19,14,15,16,17,18,19,26,21,31,22,23,25,26,23,25,21,16],
			    data1: [23, 13, 28, 38, 40, 30, 21,26,21,31,22,23,25,26,23,25,21,16,20,16,18,17,17,16,19,14,15,16,17,18]
			})
            this.barChart()
            this.pieChart2({
                dom: 'pieChart1',
                name: '死亡活畜',
                color: ['#FE982C', '#00FEFF', '#04FF00'],
                data: [
                    { value: Number(0), name: '种公羊' },
                    { value: Number(0), name: '基础母羊', selected: true },
                    { value: Number(0), name: '其他' },
                ]
            })
            this.pieChart({
                dom: 'pieChart2',
                name: '淘汰活畜',
                color: ['#00FEFF', '#FFF200', '#5D2CFE'],
                data: [
                    { value: 1, name: '种公羊' },
                    { value: 2, name: '基础母羊', selected: true },
                    { value: 3, name: '其他' },
                ]
            })
            // this.ringChart([30, 22])
            this.barChart1([1, 2, 3, 3, 4, 3,2,1,1,7,1,6,1,4,5,1,7,1,9,2,1,3,2,3,5,6,3,5,1,6], [3, 1, 7, 9, 4, 0, 2,5, 2, 6, 3, 9, 5,0,1,8,7,7,6,9,1,5,6,7,8,1,6,1,3,2])
            this.ringChart1()
        })
    },
    update() {

    },
    methods: {
		getLastMonth(range) {
			let timestamps=[]
			var now = new Date();
			var timestamp =Date.parse(new Date());
			let month=(new Date(timestamp).getMonth())+1
			let year=((new Date(timestamp).getFullYear())+'').slice(-2)
			if(range==3||range==6){
				for(let i=0 ; i<range;i++){
					
					
					// let day=new Date(timestamp).getDate()
					let monthLabel=month>=10?month:('0'+month)
					timestamps.unshift(year+'-'+monthLabel)
					if(month-1==0){
						month=12
						year=year-1
					}else{
						month=month-1
					}
					
					
					
				}
				console.log(timestamp)
				return timestamps
			}
			
			
			for(let i=0 ; i<range;i++){
				let month=new Date(timestamp).getMonth()+1
				let day=(new Date(timestamp).getDate())>=10?(new Date(timestamp).getDate()):('0'+new Date(timestamp).getDate())
				// let day=new Date(timestamp).getDate()
				
				timestamps.unshift(month+'-'+day)
				timestamp=timestamp-1000*60*60*24
				console.log(timestamp)
			}
			return timestamps
			console.log(timestamps)
		},
	
        mouseover() {
            var divs = [...document.querySelectorAll('.dialog .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        details(val) {
            if( this.dialogTxet!="体温"){
                val.row[2]='1号圈舍，耳标编号为230304010809的活畜出现体温异常预警，当前体温38度，请您及时跟踪处理！'
            }
            window.localStorage.setItem('WARNINFO',JSON.stringify(val))
            this.$router.push({ name: 'archive' })
            this.scrolling()
        },
        goDialog(v) {
            this.dialogTxet = v
            this.config = { ...this.config, data: [['230304010008',new Date().toLocaleDateString().replace(/\//g, '-')+' 10:15:13','',`<span style="border: 0.01rem solid rgba(0,117,126,0.3);padding:.05rem .1rem;color:#00D7D3;cursor:pointer;background: rgba(255, 255, 255, 0.1);">查看档案</span>`]] }
            this.isShow = true
            this.NoScrolling()
        },
        close() {
            this.isShow = false
            this.scrolling()
        },
        changeTab1(val) {
			console.log(1111)
            if (val == 1) {
                this.$nextTick(() => {
                    this.lineChart({
                        dom: 'lineChart',
                        xAxis:this.getLastMonth(31),
                        data: [14, 25, 35, 30, 49, 35, 20,26, 36, 30, 49, 35,20,16,18,26, 36, 30, 49, 35,20,16,18,21,26,21,31,22,23,25],
                        data1: [23, 12, 27, 39, 40, 30, 21,15, 26, 36, 30, 49, 35,20,16,18,17,17,16,19,14,15,16,17,18,19,26,21,31,22]
                    })
                })
            }
            if (val == 3) {
				console.log(this.getLastMonth(3))
                this.$nextTick(() => {
                    this.lineChart({
                        dom: 'lineChart',
                        xAxis: this.getLastMonth(3),
                        data: [156, 296, 256],
                        data1: [164, 263, 128]
                    })
                })
            } if (val == 6) {
                this.$nextTick(() => {
                    this.lineChart({
                        dom: 'lineChart',
                        xAxis: this.getLastMonth(6),
                        data:[256, 416, 389, 411,565,256],
                        data1: [399, 430, 678, 589, 400, 560]
                    })
                })
            }
        },
        changeTab2(val) {
            if (val == 1) {
                this.$nextTick(() => {
                    this.pieChart({
                        dom: 'pieChart1',
                        name: '死亡活畜',
                        color: ['#FE982C', '#00FEFF', '#04FF00'],
                        data: [
                            { value: Number(0), name: '种公羊' },
                            { value: Number(0), name: '基础母羊', selected: true },
                            { value: Number(0), name: '其他' },
                        ]
                    })
                    this.pieChart({
                        dom: 'pieChart2',
                        name: '淘汰活畜',
                        color: ['#00FEFF', '#FFF200', '#5D2CFE'],
                        data: [
                            { value: 1, name: '种公羊' },
                            { value: 2, name: '基础母羊', selected: true },
                            { value: 3, name: '其他' },
                        ]
                    })
                })
            }
            if (val == 3) {
                this.$nextTick(() => {
                    this.pieChart({
                        dom: 'pieChart1',
                        name: '死亡活畜',
                        color: ['#FE982C', '#00FEFF', '#04FF00'],
                        data: [
                            { value: Number(0), name: '种公羊' },
                            { value: Number(0), name: '基础母羊', selected: true },
                            { value: Number(0), name: '其他' },
                        ]
                    })
                    this.pieChart({
                        dom: 'pieChart2',
                        name: '淘汰活畜',
                        color: ['#00FEFF', '#FFF200', '#5D2CFE'],
                        data: [
                            { value: 2, name: '种公羊' },
                            { value: 1, name: '基础母羊', selected: true },
                            { value: 1, name: '其他' },
                        ]
                    })
                })
            }
            if (val == 6) {
                this.$nextTick(() => {
                    this.pieChart({
                        dom: 'pieChart1',
                        name: '死亡活畜',
                        color: ['#FE982C', '#00FEFF', '#04FF00'],
                        data: [
                            { value: Number(0), name: '种公羊' },
                            { value: Number(0), name: '基础母羊', selected: true },
                            { value: Number(0), name: '其他' },
                        ]
                    })
                    this.pieChart({
                        dom: 'pieChart2',
                        name: '淘汰活畜',
                        color: ['#00FEFF', '#FFF200', '#5D2CFE'],
                        data: [
                            { value: 2, name: '种公羊' },
                            { value: 1, name: '基础母羊', selected: true },
                            { value: 3, name: '其他' },
                        ]
                    })
                })
            }
        },
        changeTab3(val) {
            if (val == 1) {
                this.lineChart1({
                    dom: 'lineChart1',
                    xAxis: this.getLastMonth(31),
                    data: [15, 26, 36, 30, 49, 35,20,16,18,17,17,16,19,14,15,16,17,18,19,26,21,31,22,23,25,26,23,25,21,16],
                    data1: [23, 13, 28, 38, 40, 30, 21,26,21,31,22,23,25,26,23,25,21,16,20,16,18,17,17,16,19,14,15,16,17,18]
                })
            }
            if (val == 3) {
                this.lineChart1({
                    dom: 'lineChart1',
                    xAxis: this.getLastMonth(3),
                    data: [65, 76, 52],
                    data1: [53, 53, 68,]
                })
            } if (val == 6) {
                this.lineChart1({
                    dom: 'lineChart1',
                    xAxis: this.getLastMonth(6),
                    data: [87, 96, 122,196,217,187],
                    data1: [93, 153, 165,276,255,125]
                })
            }
        },
        changeTab4(val) {
            if (val == 1) {
                this.$nextTick(() => {
                    this.barChart1([4, 3, 5, 4, 4, 2, 5,2,3,4,5,6,7,4,3,2,1,3,3,5,3,4,3,1,3,3,5,3,5,2],
					               [3, 3, 4, 2, 4, 1, 4,6,7,4,3,2,1,3,3,5,3,4,3,1,3,6,7,4,3,2,1,5,6,7])
                })
            }
            if (val == 3) {
                this.$nextTick(() => {
                    this.barChart1([48, 56, 74], 
					               [53, 38, 64])
                })
            } if (val == 6) {
                this.$nextTick(() => {
                    this.barChart1([115, 214, 95, 174, 264, 213], 
					               [319, 263, 244, 194, 416, 287])
                })
            }
        },
        changeTab5(val) {
            if (val == 1) {
                this.$nextTick(() => {
                    this.ringData1 = [
                        {
                            value: 290,
                            name: '怀孕'
                        },
                        {
                            value: 71,
                            name: '未怀孕'
                        },
                        {
                            value: 4,
                            name: '流产'
                        }
                    ]
                    this.ringChart1()
                })
            }
            if (val == 3) {
                this.$nextTick(() => {
                    this.ringData1 = [
                        {
                            value: 291,
                            name: '怀孕'
                        },
                        {
                            value: 70,
                            name: '未怀孕'
                        },
                        {
                            value: 4,
                            name: '流产'
                        }
                    ]
                    this.ringChart1()
                })
            } if (val == 6) {
                this.$nextTick(() => {
                    this.ringData1 = [
                        {
                            value: 293,
                            name: '怀孕'
                        },
                        {
                            value: 68,
                            name: '未怀孕'
                        },
                        {
                            value: 3,
                            name: '流产'
                        }
                    ]
                    this.ringChart1()
                })
            }
        },
		lineChart1(data){
			this.chart = this.$echarts.init(document.getElementById(data.dom));
			            this.chart.setOption({
			                color: ['rgba(0,246,236,1)', "rgba(255,217,28,1)"],
			                title: {
			                    text: "",
			                },
			                legend: {
			                    icon: 'rectangle',
			                    data: [{
			                        name: '出生数量',
			                        textStyle: {
			                            fontSize: 12,
			                            color: 'rgba(0,246,236,1)'
			                        }
			                    }, {
			                        name: '断奶数量',
			                        textStyle: {
			                            fontSize: 12,
			                            color: 'rgba(255,217,28,1)'
			                        }
			                    }],
			                    x: 'right',
			                    y: 'top',
			                    itemWidth: 15,
			                    itemHeight: 2,
			                    padding: [30, 0, 0, 0]
			                },
			                tooltip: {
			                    trigger: 'axis',
			                    backgroundColor: "rgba(196,196,196,0.01);",
			                    borderColor: " rgba(0,246,236,0.2)",
			                    boxShadow: "inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)",
			                    borderWidth: 2,
			                    textStyle: {
			                        color: "#fff"
			                    },
			                    formatter: function (data1) {
			                        let dom = '';
									console.log(data)
			                        data1.forEach(item => {
										let timeLine=''
										if(data.data.length==3||data.data.length==6){
											let year=item.axisValueLabel.split('-')[0]+'年'
											let month=item.axisValueLabel.split('-')[1]+'月'
											timeLine=year+month
										}else{
											let month=item.axisValueLabel.split('-')[0]+'月'
											let day=item.axisValueLabel.split('-')[1]+'日'
											timeLine=month+day
										}
										// console.log(item)
										// let month=item.axisValueLabel.split('-')[0]+'月'
										// let day=item.axisValueLabel.split('-')[1]+'日'
			                            dom += `<p>
											${timeLine}
			                                ${item.marker}
			                                ${item.seriesName}： 
			                                ${item.value}只
			                            </p>`
			                        })
			                        return `<div>${dom}</div>`
			                    },
			                },
			                grid: {
			                    left: "0%",
			                    right: "5%",
			                    bottom: "0%",
			                    containLabel: true,
			                },
			                xAxis: [
			                    {
			                        type: "category",
			                        boundaryGap: true,
			                        axisLabel: {
			                            color: "#05E9F7",
			                            // interval: 0,
			                            // rotate: 45	,
			                        },
			                        axisLine: {
			                            show: true, // X轴 网格线 颜色类型的修改
			                            lineStyle: {
			                                color: " rgba(0,254,255,0.1)",
			                            },
			                        },
			                        axisTick: {
			                            // X轴线 刻度线
			                            show: false,
			                        },
			                        data: data.xAxis,
			                    },
			                ],
			                yAxis: [
			                    {
			                        name: "单位：只",
			                        nameTextStyle: {
			                            color: "#05E9F7",
			                            padding: [1, 1],
			                        },
			                        splitLine: false,
			                        type: "value",
			                        axisLine: {
			                            show: true, // Y轴线
			                            lineStyle: {
			                                color: " rgba(0,254,255,0.1)",
			                            },
			                        },
			                        axisLabel: {
			                            color: "#05E9F7",
			                        },
			                    },
			                ],
			                series: [
			                    {
			                        name: "出生数量",
			                        type: "line",
			                        lineStyle: {
			                            width: 2,
			                        },
			                        showSymbol: false,
			                        areaStyle: {
			                            opacity: 0.8,
			                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
			                                {
			                                    offset: 1,
			                                    color: "rgba(91,233,255,0)",
			                                },
			                                {
			                                    offset: 0,
			                                    color: "rgba(0,246,236,0.48)",
			                                },
			                            ]),
			                        },
			                        data: data.data,
			                    },
			                    {
			                        name: "断奶数量",
			                        type: "line",
			                        lineStyle: {
			                            width: 2,
			                        },
			                        showSymbol: false,
			                        areaStyle: {
			                            opacity: 0.8,
			                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
			                                {
			                                    offset: 1,
			                                    color: "rgba(255,217,28,0)",
			                                },
			                                {
			                                    offset: 0,
			                                    color: "rgba(255,217,28,0.48)",
			                                },
			                            ]),
			                        },
			                        data: data.data1,
			                    },
			                ],
			            });

						
		},
        lineChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom));
			console.log(data)
            this.chart.setOption({
                color: ['rgba(0,246,236,1)', "rgba(255,217,28,1)"],
                title: {
                    text: "",
                },
                
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: "rgba(196,196,196,0.01);",
                    borderColor: " rgba(0,246,236,0.2)",
                    boxShadow: "inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)",
                    borderWidth: 2,
                    textStyle: {
                        color: "#fff"
                    },
                    formatter: function (data1) {
                        let dom = '';
						console.log(data)
                        data1.forEach(item => {
							let timeLine=''
							if(data.length==3||data.length==6){
								let year=item.axisValueLabel.split('-')[0]+'年'
								let month=item.axisValueLabel.split('-')[1]+'月'
								timeLine=year+month
							}else{
								let month=item.axisValueLabel.split('-')[0]+'月'
								let day=item.axisValueLabel.split('-')[1]+'日'
								timeLine=month+day
							}
							
							console.log(item)
                            dom += `<p>
								${timeLine}
                                ${item.marker}
                                ${item.seriesName}:
								${item.value}只
                                ${((item.value/(data1[0].value+data1[1].value))*100).toFixed(2)}%
                            </p>`
                        })
                        return `<div>${dom}</div>`
                    },
                },
                grid: {
                    left: "0%",
                    right: "3%",
                    bottom: "0%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: "category",
                        // boundaryGap: false,
                        axisLabel: {
                            color: "#05E9F7",
                            // interval: 0,
                            // rotate: 40,
                        },
                        axisLine: {
                            show: true, // X轴 网格线 颜色类型的修改
                            lineStyle: {
                                color: " rgba(0,254,255,0.1)",
                            },
                        },
                        axisTick: {
                            // X轴线 刻度线
                            show: false,
                        },
                        data: data.xAxis,
                    },
                ],
                yAxis: [
                    {
                        name: "单位：只",
                        nameTextStyle: {
                            color: "#05E9F7",
                            padding: [1, 1],
                        },
                        splitLine: false,
                        type: "value",
                        axisLine: {
                            show: true, // Y轴线
                            lineStyle: {
                                color: " rgba(0,254,255,0.1)",
                            },
                        },
                        axisLabel: {
                            color: "#05E9F7",
                        },
                    },
                ],
                series: [
                    {
                        name: "单羔",
                        type: "bar",
						stack: '业务',
                        // lineStyle: {
                        //     width: 2,
                        // },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: "rgba(91,233,255,0)",
                                },
                                {
                                    offset: 0,
                                    color: "rgba(0,246,236,0.48)",
                                },
                            ]),
                        },
                        data: data.data,
                    },
                    {
                        name: "双羔",
                        type: "bar",
						stack: '业务',
                        // lineStyle: {
                        //     width: 2,
                        // },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: "rgba(255,217,28,0)",
                                },
                                {
                                    offset: 0,
                                    color: "rgba(255,217,28,0.48)",
                                },
                            ]),
                        },
                        data: data.data1,
                    },
                ],
            });
        },
        barChart() {
            this.chart = this.$echarts.init(document.getElementById('barChart'));
            // 隐藏动画加载效果。
            this.chart.setOption({
                // color: ['#0083FF', '#05E9F7', '#00FF34'],
                color: ['#00DAC8', '#F9B907', '#00E0EE'],
                legend: {
                    icon: 'circle',
                    color: 'rgba(0,246,236,1)',
                    data: [{
                        name: '配种',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(0,246,236,1)'
                        }
                    }, {
                        name: '怀孕',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(0,246,236,1)'
                        }
                    }, {
                        name: '新产',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(0,246,236,1)'
                        }
                    }, {
                        name: '不孕',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(0,246,236,1)'
                        }
                    }],
                    x: 'center',
                    y: 'top',
                    itemWidth: 15,
                    itemHeight: 15,
                    padding: [30, 0, 0, 0],
                    borderRadius: '50%'
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: "rgba(196,196,196,0.01);",
                    borderColor: " rgba(0,246,236,0.2)",
                    boxShadow: "inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)",
                    borderWidth: 2,
                    textStyle: {
                        color: "#fff"
                    },
                    formatter: function (data) {
                        const name = data[0].name.split('\n')[0]
                        let dom = `<div style='width: 150px'>
                            <h3 style='
                                text-align: center;
                                font-size: 16px;
                                font-weight: 400;
                                color: #FFFFFF;'>${name}</h3>   
                            <div style='display: flex; flex-wrap: wrap'> 
                        `;
                        data.forEach(item => {
                            dom += `<div style='width: 50%; display: flex;'>
                                <p>${item.marker}</p>
                                <div>
                                    <p style='color: #00FEFF;font-weight: 700;'>${item.value}</p> 
                                    <p>${item.seriesName}</p>
                                </div>
                            </div>`
                        })
                        return `<div>${dom}</div>`
                    },
                },
                grid: {
                    left: "0%",
                    right: "3%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: [{
                            value: '第一季度\n（三、四、五月）',
                            textStyle: {
                                lineHeight: 16,
                                formatter: [
                                    '{a}',
                                    '{b}'
                                ].join('\n')
                            }
                        }, {
                            value: '第二季度\n（三、四、五月）',
                            textStyle: {
                                lineHeight: 16,
                                formatter: [
                                    '{a}',
                                    '{b}'
                                ].join('\n')
                            }
                        }, {
                            value: '第三季度\n（三、四、五月）',
                            textStyle: {
                                lineHeight: 16,
                                formatter: [
                                    '{a}',
                                    '{b}'
                                ].join('\n')
                            }
                        }, {
                            value: '第四季度\n（三、四、五月）',
                            textStyle: {
                                lineHeight: 16,
                                formatter: [
                                    '{a}',
                                    '{b}'
                                ].join('\n')
                            }
                        }],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            show: false, // Y轴线
                            lineStyle: {
                                color: " rgba(0,254,255,0.1)",
                            },
                        },
                        axisTick: {
                            // X轴线 刻度线
                            show: false,
                        },
                        axisLabel: {
                            color: "#05E9F7",
                        }
                    }
                ],
                yAxis: [
                    {
                        show: false,
                    }
                ],
                series: [
                    {
                        name: '配种',
                        type: 'bar',
                        barWidth: '6',
                        data: [
                            76.7, 135.6, 162.2, 32.6
                        ],
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            barBorderRadius: [20, 20, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#0083FF' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(0,131,255,0)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },

                        },
                    },
                    {
                        name: '怀孕',
                        type: 'bar',
                        barWidth: '6',
                        data: [
                            28.7, 70.7, 175.6, 182.2
                        ],
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            barBorderRadius: [20, 20, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FF3C00' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(255,60,0,0)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },
                        },
                    },
                    {
                        name: '新产',
                        type: 'bar',
                        barWidth: '6',
                        data: [
                            70.7, 175.6, 182.2, 48.7
                        ],
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            barBorderRadius: [20, 20, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#00FF34' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(0,255,52,0)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },
                        },
                    },
                    {
                        name: '不孕',
                        type: 'bar',
                        barWidth: '6',
                        barGap: '200%',
                        data: [
                            175.6, 182.2, 48.7, 18.8
                        ],
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            barBorderRadius: [20, 20, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#5D2CFE' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(93,44,254,0)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            },
                        },
                    }
                ]
            })
        },
        pieChart(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom));
            this.chart.setOption({
                title: {
                    text: data.name,
                    x: 'center',
                    y: 'bottom',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    }
                },
                color: data.color,
                legend: {
                    show: false
                },
                series: [
                    {
                        type: 'pie',
                        radius: '65%',
                        center: ['50%', '50%'],
                        selectedMode: true,
                        labelLine: {
                            show: false
                        },
                        label: {
                            position: 'inner',
                            fontSize: 14,
                            // formatter: '{b}\n   {d}% ',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '%'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '%'
                                } else {
                                    return params.name + params.percent + '%'
                                }
                            }
                        },
                        data: data.data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        },
        pieChart2(data) {
            this.chart = this.$echarts.init(document.getElementById(data.dom));
            this.chart.setOption({
                title: {
                    text: data.name,
                    x: 'center',
                    y: 'bottom',
                    textStyle: {
                        color: '#fff',
                        fontSize: 14
                    }
                },
                color: data.color,
                legend: {
                    show: false
                },
                series: [
                    {
                        type: 'pie',
                        radius: '65%',
                        center: ['50%', '50%'],
                        selectedMode: true,
                        labelLine: {
                            show: false
                        },
                        label: {
                            position: 'inner',
                            fontSize: 14,
                            // formatter: '{b}\n   {d}% ',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '%'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '%'
                                } else {
                                    return params.name + params.percent + '%'
                                }
                            }
                        },
                        data: data.data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        },
        ringChart(data) {
            this.chart = this.$echarts.init(document.getElementById('ringChart'));
            this.chart.setOption({
                color: ['#04FF00', '#00FEFF'],
                tooltip: {
                    show: false
                },
                legend: {
                    show: false
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: ['30%', '70%'],
                        selectedMode: true,
                        data: [
                            { value: data[0], name: '母羊' },
                            { value: data[1], name: '公羊', selected: true }
                        ],
                        label: {
                            formatter: ' {b|{b}} \n {per|{d}%}',
                            // formatter: function(item) {
                            //     return `
                            //         <p style='font-size: 14px;color:${item.color}'>${item.name}</p>
                            //         <p style='font-size: 14px;color:${item.color}'>${item.percent}%</p>
                            //     `
                            // },
                            borderWidth: 1,
                            edgeDistance: 10,
                            borderRadius: 4,
                            color: (params) => {
                                var index = params.dataIndex;
                                return ['#04FF00', '#00FEFF'][index];
                            },
                            rich: {
                                b: {
                                    fontSize: 14,
                                    fontWeight: 'bold',
                                    lineHeight: 33
                                },
                                per: {
                                    padding: [3, 4],
                                }
                            },
                        },
                        labelLine: {
                            length: 15,
                            maxSurfaceAngle: 80
                        },
                        itemStyle: {
                            color: (params) => {
                                var index = params.dataIndex;
                                return ['#04FF00', '#00FEFF'][index];
                            },
                        },
                        // labelLayout: function (params) {
                        //     const isLeft = params.labelRect.x < this.chart.getWidth() / 2;
                        //     const points = params.labelLinePoints;
                        //     // Update the end point.
                        //     points[2][0] = isLeft
                        //     ? params.labelRect.x
                        //     : params.labelRect.x + params.labelRect.width;
                        //     return {
                        //         labelLinePoints: points
                        //     };
                        // },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
        },
        barChart1(data1, data2) {
            this.chart = this.$echarts.init(document.getElementById('barChart1'));
			
            // 隐藏动画加载效果。
            this.chart.setOption({
                // color: ['#0083FF', '#05E9F7', '#00FF34'],
                color: ['#00DAC8', '#F9B907', '#00E0EE'],
                legend: {
                    icon: 'rectangle',
                    data: [{
                        name: '发病数',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(0, 254, 255, 1)'
                        }
                    }, {
                        name: '治愈数',
                        textStyle: {
                            fontSize: 12,
                            color: 'rgba(255, 242, 0, 1)'
                        }
                    }],
                    x: 'right',
                    y: 'top',
                    itemWidth: 12,
                    itemHeight: 12,
                    padding: [30, 0, 0, 0],
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: "rgba(196,196,196,0.01);",
                    borderColor: " rgba(0,246,236,0.2)",
                    boxShadow: "inset 0rem 0rem 0.06rem 0rem rgba(0,117,255,0.6)",
                    borderWidth: 2,
                    textStyle: {
                        color: "#fff"
                    },
                    formatter: function (data) {
                        let dom = '';
                        data.forEach(item => {
							let timeLine=''
							if(data1.length==3||data1.length==6){
								let year=item.axisValueLabel.split('-')[0]+'年'
								let month=item.axisValueLabel.split('-')[1]+'月'
								timeLine=year+month
							}else{
								let month=item.axisValueLabel.split('-')[0]+'月'
								let day=item.axisValueLabel.split('-')[1]+'日'
								timeLine=month+day
							}
							let month=item.axisValueLabel.split('-')[0]+'月'
							let day=item.axisValueLabel.split('-')[1]+'日'
                            dom += `<p>
								${timeLine}
                                ${item.marker}
                                ${item.seriesName}： 
                                ${item.value}只
                            </p>`
                        })
                        return `<div>${dom}</div>`
                    },
                },
                grid: {
                    left: "0%",
                    right: "0%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.getLastMonth(data1.length),
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine: {
                            show: true, // Y轴线
                            lineStyle: {
                                color: " rgba(0,254,255,0.1)",
                            },
                        },
                        axisTick: {
                            // X轴线 刻度线
                            show: false,
                        },
                        axisLabel: {
                            color: "#05E9F7",
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位：只",
                        nameTextStyle: {
                            color: "#05E9F7",
                            padding: [1, -30, 0, 0],
                        },
                        splitLine: false,
                        type: "value",
                        axisLine: {
                            show: true, // Y轴线
                            lineStyle: {
                                color: " rgba(0,254,255,0.1)",
                            },
                        },
                        axisLabel: {
                            color: "#05E9F7",
                        },
                    },
                ],
                series: [
                    {
                        name: '发病数',
                        type: 'bar',
                        barGap: '0',
                        barWidth: 5,
                        data: data1,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            color: '#00FEFF',

                        },
                    },
                    {
                        name: '治愈数',
                        type: 'bar',
                        barWidth: 5,
                        data: data2,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            color: '#FFF200',
                        },
                    }
                ]
            })
        },
        // ringChart1() {
        //     let color = this.ringColor;
        //     let data1 = 0;
        //     this.ringData1.forEach(item => {
        //         data1 += item.value
        //     })
        //     let baseData = [];
        //     for (var i = 0; i < this.ringData1.length; i++) {
        //         baseData.push({
        //             value: this.ringData1[i].value,
        //             name: this.ringData1[i].name,
        //             itemStyle: {
        //                 normal: {
        //                     borderWidth: 20,
        //                     shadowBlur: 10,
        //                     borderColor: color[i],
        //                     borderRadius: 20,
        //                 },
        //             },
        //         });
        //     }
        //     this.chart = this.$echarts.init(document.getElementById('ringChart1'));
        //     // 隐藏动画加载效果。
        //     this.chart.setOption({
        //         title: {
        //             text: '',
        //         },
        //         color: color,
        //         tooltip: {
        //             show: false,
        //             trigger: 'item',
        //             formatter: '{b} <br/>占比：{d}%',
        //         },
        //         legend: {
        //             show: false,
        //         },
        //         grid: {
        //             top: 'bottom',
        //             left: 10,
        //             bottom: 10,
        //             width: '50%',
        //             height: '50%',
        //         },
        //         series: [
        //             {
        //                 zlevel: 1,
        //                 name: '',
        //                 type: 'pie',
        //                 selectedMode: 'single',
        //                 radius: [60, 110],
        //                 center: ['50%', '50%'],
        //                 startAngle: 60,
        //                 // hoverAnimation: false,
        //                 label: {
        //                     normal: {
        //                         position: 'inside',
        //                         show: true,
        //                         color: '#fff',
        //                         formatter: function (params) {
        //                             return params.percent.toFixed() + '%';
        //                         },
        //                         rich: {
        //                             b: {
        //                                 fontSize: 16,
        //                                 lineHeight: 30,
        //                                 color: '#fff',
        //                             },
        //                         },
        //                     },
        //                 },
        //                 itemStyle: {
        //                     normal: {
        //                         shadowColor: 'rgba(0, 0, 0, 0.2)',
        //                         shadowBlur: 5,
        //                     },
        //                 },
        //                 data: baseData,
        //             },
        //             {
        //                 name: '',
        //                 type: 'pie',
        //                 selectedMode: 'single',
        //                 radius: [60, 110],
        //                 center: ['50%', '50%'],
        //                 // startAngle: 60,
        //                 data: [
        //                     {
        //                         value: data1,
        //                         name: '',
        //                         label: {
        //                             normal: {
        //                                 show: true,
        //                                 formatter: '{b|初检总数} \n {c|{c}} ',
        //                                 position: 'center',
        //                                 rich: {
        //                                     c: {
        //                                         color: 'rgba(255, 242, 0, 1)',
        //                                         fontSize: 38,
        //                                         fontWeight: 'bold',
        //                                         lineHeight: 58,
        //                                         align: 'center',
        //                                         padding: [30, 0, 30, 0],
        //                                     },
        //                                     b: {
        //                                         align: 'center',
        //                                         color: '#FFF',
        //                                         fontSize: 20,
        //                                         padding: [16, 0, -10, -10],
        //                                     },
        //                                 },
        //                             },
        //                         },
        //                     },
        //                 ],
        //             },
        //         ],
        //     })
        // }
        ringChart1() {
            let totalValue = 0
            this.ringData1.forEach((item) => {
                totalValue += item.value
            }, 0)
            this.chart = this.$echarts.init(document.getElementById('ringChart1'));
            // 隐藏动画加载效果。
            this.chart.setOption({
                color: this.ringColor,
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['60%', '80%'],
                        center: ['50%', '60%'],
                        // adjust the start angle
                        startAngle: 180,
                        label: {
							
                            show: true,
                            formatter(param) {
                                // correct the percentage
                                return param.name + ' (' + param.percent * 2 + '%)';
                            }
                        },
                        data: [
                            {
                                value: 1048,
                                name: 'Search Engine',
                                label: {
                                    show: false
                                }
                            },
                            {
                                value: 735,
                                name: 'Direct',
                                label: {
                                    show: false
                                }
                            },
                            {
                                value: 580, name: 'Email',
                                label: {
                                    show: false
                                }
                            },
                            {
                                // make an record to fill the bottom 50%
                                value: (1048 + 735 + 580),
                                itemStyle: {
                                    // stop the chart from rendering this piece
                                    color: 'none',
                                    decal: {
                                        symbol: 'none'
                                    }
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        formatter: '{b|   初检总数} \n\n {c|' + totalValue + '} ',
                                        position: 'center',
                                        rich: {
                                            c: {
                                                color: 'rgba(255, 242, 0, 1)',
                                                fontSize: 38,
                                                fontWeight: 'bold',
                                                lineHeight: 58,
                                                align: 'center',
                                                padding: [30, 0, 30, 0],
                                            },
                                            b: {
                                                align: 'center',
                                                color: '#FFF',
                                                fontSize: 20,
                                                padding: [16, 0, -10, -10],
                                            },
                                        },
                                    },
                                },
                            }
                        ]
                    }
                ]
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    background: url('../../../assets/yq/animal-bg.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;

    .head {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        background: url('../../../assets/yq/headbg.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #19ECFF;
        letter-spacing: 5px;
    }


    .gobcak {
        width: .875rem;
        height: .4375rem;
        position: absolute;
        z-index: 99;
        bottom: -0.25rem;
        left: 0.25rem;
        font-size: .2rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #00E0DB;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: .3rem;
            height: .3rem;
        }

        span {
            margin-left: .05rem;
        }
    }


    .content {
        padding: .41rem 0.39rem;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        flex-direction: column;
        // min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        position: relative;

        .box {
            width: 100%;
            display: flex;
            flex-direction: column;
            flex: 1;
            background: url('../../../assets/yq/fold/rectangle1.png');

            // background-position: ;
            .box-content {
                flex: 1;
                padding: 0 0.29rem;
                padding-bottom: 0.25rem;
                display: flex;
                justify-content: space-between;

                .box-item {
                    width: 7.38rem;
                    height: 10.35rem;

                    .chart_item {
                        width: 7.38rem;
                        height: 5rem;
                        padding: 0.25rem 0.13rem 0 0.25rem;
                        box-sizing: border-box;
                        background: url('../../../assets/yq/fold/rectangle2.png');
                    }

                    .mb38 {
                        margin-bottom: 0.25rem;
                    }

                    .total {
                        display: flex;
                        margin-top: 0.31rem;

                        .total_item {
                            margin-right: 0.76rem;
                            display: flex;
                            flex-direction: column;
                            cursor: pointer;

                            span {
                                font-size: 0.25rem;
                                font-family: Impact-Regular, Impact;
                                font-weight: 400;
                                color: #FFF200;
                                line-height: 0.38rem;
                                letter-spacing: 1px;
                            }

                            label {
                                font-size: 0.15rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 0.18rem;
                                margin-top: 0.1rem;
                            }

                            &:last-child {
                                margin: 0;
                            }
                        }

                        .c_00FEFF {
                            span {
                                color: #00FEFF;
                            }
                        }

                        .ml_lg {
                            margin-left: 0.4rem;
                        }
                    }

                    .line_chart,
                    .bar_chart,
                    .ring_chart,
                    .bar_chart1 {
                        width: 6.8rem;
                        height: 3.25rem;
                    }

                    .ring_chart {
                        height: 4rem;
                        margin-top: 0.6rem;
                    }

                    .ring_box {
                        display: flex;
                        margin-top: 0.4rem;

                        .ring_chart1 {
                            width: 4.5rem;
                            height: 4rem;
                        }

                        .ring_legend {
                            width: 2rem;

                            .legend_item {
                                display: flex;
                                justify-content: space-between;
                                font-size: 0.23rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #FFFFFF;
                                margin-top: 0.48rem;

                                &:first-child {
                                    margin-top: 1rem;
                                }

                                span {
                                    display: inline-block;
                                    width: 0.16rem;
                                    height: 0.16rem;
                                    border-radius: 4px 4px 4px 4px;
                                }
                            }
                        }
                    }

                    .pie_box {
                        display: flex;
                        margin-top: 0.2rem;

                        .pie_chart1,
                        .pie_chart2 {
                            flex: 1;
                            height: 4rem;
                        }
                    }
                }
            }

        }
    }
    .dialog-box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: transparent;
        opacity: 1;
        z-index: 99999999;

        .dialog {
            // position: fixed;
            // top: 50%;
            // left: 50%;
            // transform: translate(-5.625rem, -2.315rem);
            width: 11.25rem;
            height: 4.63rem;
            background: url('../../../assets/yq/warn/dialogbg.png');
            background-size: 100% 100%;

            .headers {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 0.48rem;
                background: rgba(0, 174, 255, 0.6);
                border-radius: 0.05rem 0.05rem 0rem 0rem;
                padding-left: .25rem;
                padding-right: .11rem;

                span:nth-child(1) {
                    position: relative;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #00FEFF;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0.05rem;
                        bottom: -0.15rem;
                        width: 0.75rem;
                        height: 0.03rem;
                        background: #00FEFF;
                    }
                }

                span:nth-child(2) {
                    font-size: 0.28rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }
        }
    }


}
</style>
<style lang="scss">
.partner {

    .partner .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    // .el-select > .el-input{
    //     width: auto;
    // }
    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: 0.01rem solid rgba(25, 236, 255, 0.4);
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        // padding: 0 0 0 .4rem;
        width: 3.23rem !important;
    }

    .header {
        background: rgba(0, 174, 255, 0.3) !important;
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #19ECFF;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        // height: 3.5rem!important;
        padding: .05rem 0 .3rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                // margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        // color: #FFC300;
    }

    // 排名轮播
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }

}
</style>